/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTimelineContentAddPost } from '../fn/timeline-content/api-master-timeline-content-add-post';
import { ApiMasterTimelineContentAddPost$Params } from '../fn/timeline-content/api-master-timeline-content-add-post';
import { apiMasterTimelineContentDeleteGet } from '../fn/timeline-content/api-master-timeline-content-delete-get';
import { ApiMasterTimelineContentDeleteGet$Params } from '../fn/timeline-content/api-master-timeline-content-delete-get';
import { apiMasterTimelineContentEditPost } from '../fn/timeline-content/api-master-timeline-content-edit-post';
import { ApiMasterTimelineContentEditPost$Params } from '../fn/timeline-content/api-master-timeline-content-edit-post';
import { apiMasterTimelineContentGetActiveGet } from '../fn/timeline-content/api-master-timeline-content-get-active-get';
import { ApiMasterTimelineContentGetActiveGet$Params } from '../fn/timeline-content/api-master-timeline-content-get-active-get';
import { apiMasterTimelineContentGetAllGet } from '../fn/timeline-content/api-master-timeline-content-get-all-get';
import { ApiMasterTimelineContentGetAllGet$Params } from '../fn/timeline-content/api-master-timeline-content-get-all-get';
import { apiMasterTimelineContentGetByCriteriaPost } from '../fn/timeline-content/api-master-timeline-content-get-by-criteria-post';
import { ApiMasterTimelineContentGetByCriteriaPost$Params } from '../fn/timeline-content/api-master-timeline-content-get-by-criteria-post';
import { apiMasterTimelineContentGetByIdGet } from '../fn/timeline-content/api-master-timeline-content-get-by-id-get';
import { ApiMasterTimelineContentGetByIdGet$Params } from '../fn/timeline-content/api-master-timeline-content-get-by-id-get';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { TimelineContent } from '../models/timeline-content';
import { TimelineContentApiRespModel } from '../models/timeline-content-api-resp-model';

@Injectable({ providedIn: 'root' })
export class TimelineContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTimelineContentAddPost()` */
  static readonly ApiMasterTimelineContentAddPostPath = '/api/Master/TimelineContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentAddPost$Response(params?: ApiMasterTimelineContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TimelineContentApiRespModel>> {
    return apiMasterTimelineContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentAddPost(params?: ApiMasterTimelineContentAddPost$Params, context?: HttpContext): Observable<TimelineContentApiRespModel> {
    return this.apiMasterTimelineContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TimelineContentApiRespModel>): TimelineContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentEditPost()` */
  static readonly ApiMasterTimelineContentEditPostPath = '/api/Master/TimelineContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentEditPost$Response(params?: ApiMasterTimelineContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TimelineContentApiRespModel>> {
    return apiMasterTimelineContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentEditPost(params?: ApiMasterTimelineContentEditPost$Params, context?: HttpContext): Observable<TimelineContentApiRespModel> {
    return this.apiMasterTimelineContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TimelineContentApiRespModel>): TimelineContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentDeleteGet()` */
  static readonly ApiMasterTimelineContentDeleteGetPath = '/api/Master/TimelineContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentDeleteGet$Response(params?: ApiMasterTimelineContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTimelineContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentDeleteGet(params?: ApiMasterTimelineContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTimelineContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentGetByIdGet()` */
  static readonly ApiMasterTimelineContentGetByIdGetPath = '/api/Master/TimelineContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetByIdGet$Response(params?: ApiMasterTimelineContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TimelineContent>> {
    return apiMasterTimelineContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetByIdGet(params?: ApiMasterTimelineContentGetByIdGet$Params, context?: HttpContext): Observable<TimelineContent> {
    return this.apiMasterTimelineContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TimelineContent>): TimelineContent => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentGetAllGet()` */
  static readonly ApiMasterTimelineContentGetAllGetPath = '/api/Master/TimelineContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetAllGet$Response(params?: ApiMasterTimelineContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimelineContent>>> {
    return apiMasterTimelineContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetAllGet(params?: ApiMasterTimelineContentGetAllGet$Params, context?: HttpContext): Observable<Array<TimelineContent>> {
    return this.apiMasterTimelineContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TimelineContent>>): Array<TimelineContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentGetActiveGet()` */
  static readonly ApiMasterTimelineContentGetActiveGetPath = '/api/Master/TimelineContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetActiveGet$Response(params?: ApiMasterTimelineContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimelineContent>>> {
    return apiMasterTimelineContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTimelineContentGetActiveGet(params?: ApiMasterTimelineContentGetActiveGet$Params, context?: HttpContext): Observable<Array<TimelineContent>> {
    return this.apiMasterTimelineContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TimelineContent>>): Array<TimelineContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTimelineContentGetByCriteriaPost()` */
  static readonly ApiMasterTimelineContentGetByCriteriaPostPath = '/api/Master/TimelineContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTimelineContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentGetByCriteriaPost$Response(params?: ApiMasterTimelineContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimelineContent>>> {
    return apiMasterTimelineContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTimelineContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTimelineContentGetByCriteriaPost(params?: ApiMasterTimelineContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<TimelineContent>> {
    return this.apiMasterTimelineContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TimelineContent>>): Array<TimelineContent> => r.body)
    );
  }

}
